import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import {
  AssetExportCreate,
  AssetExportReadExternal,
  ErrorModel,
  OrgExportCreate,
  OrgExportReadExternal,
  TaskExportCreate,
  TaskExportReadExternal,
  TeamExportCreate,
  TeamExportReadExternal,
  UserExportCreate,
  UserExportReadExternal,
} from '@askporter/client-grieg-lyric';
import { API } from '../../../utils/api';

export const useExportMutations = () => {
  return {
    taskExportMutation: useMutation<AxiosResponse<TaskExportReadExternal>, AxiosError<ErrorModel>, TaskExportCreate>({
      mutationFn: (data: TaskExportCreate) => API().post({ path: `exports/task`, payload: data }),
    }),
    assetExportMutation: useMutation<AxiosResponse<AssetExportReadExternal>, AxiosError<ErrorModel>, AssetExportCreate>(
      {
        mutationFn: (data: AssetExportCreate) => API().post({ path: `exports/asset`, payload: data }),
      },
    ),
    userExportMutation: useMutation<AxiosResponse<UserExportReadExternal>, AxiosError<ErrorModel>, UserExportCreate>({
      mutationFn: (data: UserExportCreate) => API().post({ path: `exports/user`, payload: data }),
    }),
    orgExportMutation: useMutation<AxiosResponse<OrgExportReadExternal>, AxiosError<ErrorModel>, OrgExportCreate>({
      mutationFn: (data: OrgExportCreate) => API().post({ path: `exports/org`, payload: data }),
    }),
    teamExportMutation: useMutation<AxiosResponse<TeamExportReadExternal>, AxiosError<ErrorModel>, TeamExportCreate>({
      mutationFn: (data: TeamExportCreate) => API().post({ path: `exports/team`, payload: data }),
    }),
  };
};
